import { Component } from '@angular/core';
import { ListLayoutSingleComponent } from 'gung-list';
import { AiOrderParserItem } from '../../../models/ai-order-parser-item';

/**
 * Table layout for the order inbox: renders a shared, aligned column header
 * above the rows. The column template is defined once as a CSS variable
 * (`--oc-cols` on `.oc-table`) so the header and every {@link AiOrderParserOrderCardComponent}
 * row stay in lockstep. Rows are tracked by item id so the 30s poll doesn't
 * recreate the row hosts (precondition for the arrival highlight animation).
 */
@Component({
  selector: 'lib-pdf-ai-parser-order-list-layout',
  templateUrl: './pdf-ai-parser-order-list-layout.component.html',
  styleUrls: ['./pdf-ai-parser-order-list-layout.component.scss'],
  standalone: false
})
export class AiOrderParserOrderListLayoutComponent extends ListLayoutSingleComponent<AiOrderParserItem> {
  trackById(index: number, item: AiOrderParserItem): string {
    return item.id;
  }
}
